import { EditOutlined } from "@ant-design/icons";
import { Form, Image, Input, message } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import AntTable from "../../components/AntTableV2";
import ApiWrapper from "../../utils/ApiWrapper";
const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };

    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log("Save failed:", errInfo);
        }
    };

    let childNode = children;

    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                ]}
            >
                <Input
                    className="heightInitial text-left"
                    ref={inputRef}
                    onPressEnter={save}
                    onBlur={save}
                />
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
            >
                {children}
                <EditOutlined onClick={toggleEdit} />
            </div>
        );
    }

    return <td {...restProps}>{childNode}</td>;
};

export default function InputProductTabV2(props) {
    const components = {
        body: {
            row: EditableRow,

            cell: EditableCell,
        },
    };
    const InputProductCost = [
        {
            title: "Sno",
            align: "center",
            field: "channel",
            width: 80,
            render: (record, rowIndex) => rowIndex,
        },
        {
            title: "Channel",
            align: "center",
            field: "channel",
            width: 80,

            render: (record, rowIndex) =>
                record.channel === "Amazon-India" ? (
                    <div className="amazon-logo-small"></div>
                ) : record.channel === "Flipkart" ? (
                    <div className="flipkart-logo-small"></div>
                ) : (
                    "-"
                ),
            isFilterable: true,
            type: "string",
        },
        {
            title: "Image",
            align: "center",
            field: "productId",
            width: 100,

            render: (record, rowIndex) => (
                <Image
                    // width={70}
                    // height={70}
                    style={{
                        height: 36,
                        width: 36,
                        objectFit: "cover",
                        border: "1px solid #EAE6FF",
                    }}
                    src={record.imageURL}
                    fallback="data:image/png;base64,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"
                />
            ),
        },
        {
            title: "Name",
            align: "center",
            isFilter: true,
            field: "name",
            ellipsis: true,

            isFilterable: true,
            isSearchable: true,
            type: "string",
            render: (record, rowIndex) => record.name || "", //.replace(/(.{20})..+/, "$1…"),
            sorter: (a, b) => {
                a = (a.name || "").toLowerCase();
                b = (b.name || "").toLowerCase();
                return a > b ? -1 : b > a ? 1 : 0;
            },
            sortDirections: ["descend", "ascend", "descend"],
        },
        {
            title: "Product ID",
            align: "center",
            isFilterable: true,
            ellipsis: true,
            field: "productId",
            type: "string",
            defaultSortOrder: "descend",

            sorter: (a, b) => {
                a = (a.productId || "").toLowerCase();
                b = (b.productId || "").toLowerCase();
                return a > b ? -1 : b > a ? 1 : 0;
            },
            sortDirections: ["descend", "ascend", "descend"],
            // render: (record, rowIndex) => "-"
        },
        {
            title: "Marketplace SKU",
            align: "center",
            field: "sku",
            type: "string",
            isFilterable: true,
            isEditable: true,
            render: (record, rowIndex, isLoading) => (record.sku ? record.sku : "-"),
            searchPriority: 5,
            onSearch: (searchText) => (data) =>
                (data || "").toLowerCase().includes(searchText.toLowerCase()),
            editable: false,
            sorter: (a, b) => {
                a = (a.sku || "").toLowerCase();
                b = (b.sku || "").toLowerCase();
                return a > b ? -1 : b > a ? 1 : 0;
            },
            sortDirections: ["descend", "ascend", "descend"],
        },

        {
            title: "Selling Price",
            align: "center",
            isFilterable: true,
            isTotal: true,
            field: "price",
            type: "number",
            sorter: (a, b) => {
                a = (a || {}).price || 0;
                b = (b || {}).price || 0;
                return a - b;
            },
            sortDirections: ["descend", "ascend", "descend"],
            // render: (record, rowIndex) => "-"
        },
        {
            title: "Cost Per Unit",
            align: "center",
            isFilterable: true,
            isTotal: true,
            field: "costPerUnit",
            type: "number",
            editable: true,
            sorter: (a, b) => {
                a = (a || {}).costPerUnit || 0;
                b = (b || {}).costPerUnit || 0;
                return a - b;
            },
            sortDirections: ["descend", "ascend", "descend"],
            onCell: (record) => ({
                record,
                editable: true,
                dataIndex: "costPerUnit",
                title: "cost per unit",
                align: "center",
                handleSave: async (data) => {
                    let requestJsonBody = {
                        listings: [
                            {
                                channel: data.channel,
                                sku: data.sku,
                                costPerUnit: data.costPerUnit,
                            },
                        ],
                    };
                    // console.log(requestJsonBody);
                    ApiWrapper("updateCostPerUnit", requestJsonBody).then(
                        function (response) {
                            if (response.status) {
                                props.reloadApi(data);
                                message.warning("Updating the order cost will take few minutes to reflect in Profitability.");
                            }
                        },
                        function (error) {
                        }
                    );
                },
            }),
        },
    ];
    const onTableChange = async ({
        paginationCondition,
        sortCondition,
        filterCondition,
    }) => {
        props.tableFilterData(paginationCondition, sortCondition, filterCondition);
    };
    React.useEffect(() => {
        if (props.activeTab === "3") {
            props.setColumn(InputProductCost);
        }
    }, [props.activeTab]);
    return (
        <div>
            <AntTable
                columns={InputProductCost}
                dataSource={props.data}
                components={components}
                stickyHeader={{
                    offsetHeader: 65,
                }}
                rowKey={(row, rowIndex) => rowIndex}
                isLoading={props.isLoading}
                hideSummary={true} //!props.data?.length}
                searchText={[props.searchText]}
                totalRecords={props.pageCount}
                onDataChange={onTableChange}
            />
        </div>
    );
}
